export default {"src":"/_next/static/media/Logo_Compact_Dark.f5bfe97d.svg","height":49,"width":37};